<div class="widget" [ngClass]="{'loader-shown': loadingPosts, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-forum" [attr.aria-hidden]="loadingPosts ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-right-icon"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element heading-loading"></div>
      <table>
        <thead>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="loader-element"></div>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="loader-element"></div>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="loader-element"></div>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="loader-element"></div>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
            <td>
              <div class="loader-element"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loadingPosts ? 'true' : 'false'">

    <div class="header">
      <span class="custom-icon" aria-hidden="true">
        <span class="icon material-icons">recent_actors</span>
      </span>
      <span class="title">Forums</span>
      <a routerLink="/forums" class="show-all-posts" aria-label="Show all forum posts">
        <span>Show All Posts</span>
        <span class="icon material-icons" aria-hidden="true">open_in_new</span>
      </a>
    </div>
    
    <div class="posts">
      <table>
        <thead>
          <tr>
            <th>Post</th>
            <th>Category</th>
            <th>Replies</th>
            <th>Views</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let post of posts">
            <td>
              <div class="post">
                <div class="content">
                  <span class="icon material-icons pinned" *ngIf="post.isPinned" pTooltip="Pinned" aria-hidden="true">push_pin</span>
                  <a
                    class="text {{ post.allRead.includes(ssoUser.uid) ? 'visited' : '' }}"
                    routerLink="/forums/{{post.id}}"
                    [attr.aria-label]="post.isPinned ? 'View pinned forum post ' + post.title : 'View forum post ' + post.title"
                  >
                    {{ post.title }}
                  </a>
                </div>
                <span class="author">{{ post.createdByName }}, {{ post.createdAt | utcToCompTime: 'fullDateTime' }}</span>
              </div>
            </td>
            <td>
              <div class="category" [ngStyle]="{ 'background-color': post.category.color }">{{ post.category.name }}</div>
            </td>
            <td aria-label="Comment count">{{ post.nonHiddenCommentCount ?? 0 }}</td>
            <td aria-label="Seen count">{{ post.seenCount || 0 }}</td>
          </tr>
        </tbody>
      </table>
      <div class="empty-posts" *ngIf="posts.length === 0 && !loadingPosts">
        Nothing to show here yet.
      </div>
    </div>

  </div>
</div>